import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import {
  backgroundGrey5,
  coolGrey,
  darkBlue,
  darkOrange,
  green2,
  softAmberLight,
  softBlueLight,
  softGreenLight,
} from 'lib/css/colors';
import { BrandVerificationStatus } from 'lib/enums/BrandVerificationStatus';
import { convertToTitleCase } from 'lib/utils/stringUtils';

const STATUS_STYLES = {
  [BrandVerificationStatus.VERIFIED]: {
    background: softGreenLight,
    color: green2,
    label: 'Verified',
  },
  [BrandVerificationStatus.UNVERIFIED]: {
    background: softAmberLight,
    color: darkOrange,
    label: 'Unverified',
  },
  [BrandVerificationStatus.PENDING_VERIFICATION]: {
    background: softBlueLight,
    color: darkBlue,
    label: 'Pending Verification',
  },
  [BrandVerificationStatus.UNVERIFIABLE]: {
    background: backgroundGrey5,
    color: coolGrey,
    label: 'Unverifiable',
  },
};

function VerificationStatusBadge({ status }) {
  if (!status) {
    return <span>-</span>;
  }

  const style = STATUS_STYLES[status] || {
    background: backgroundGrey5,
    color: coolGrey,
    label: convertToTitleCase(status),
  };

  return (
    <span
      className={css(styles.badge)}
      style={{ backgroundColor: style.background, color: style.color }}
    >
      {style.label}
    </span>
  );
}

const styles = StyleSheet.create({
  badge: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
});

VerificationStatusBadge.propTypes = {
  status: PropTypes.string,
};

export default VerificationStatusBadge;
